import {match} from 'ts-pattern';

export function buildPredictionTooltip(percentage: number, willNeed: boolean): string {
  return match(willNeed)
    .with(
      true,
      () =>
        `Forecast based on similar vehicles. Model is ${percentage}% confident this part will need attention within the next year.`
    )
    .with(
      false,
      () =>
        `Forecast based on similar vehicles. Model is ${percentage}% confident no action is needed within the next year.`
    )
    .exhaustive();
}
